import { render, staticRenderFns } from "./shoplist_xq_shop_xg.vue?vue&type=template&id=62d17c21&scoped=true&"
import script from "./shoplist_xq_shop_xg.vue?vue&type=script&lang=js&"
export * from "./shoplist_xq_shop_xg.vue?vue&type=script&lang=js&"
import style0 from "./shoplist_xq_shop_xg.vue?vue&type=style&index=0&id=62d17c21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d17c21",
  null
  
)

export default component.exports